<template>
    <div
        v-if="job"
        class="article--simple | container--lg gutter--xs"
    >
        <header class="article__header">
            <h1 class="header header-lg">{{ job.title }}</h1>
            <h6 class="subheader">{{ job.location.name }}</h6>
        </header>

        <div
            v-html="content"
            class="article__lead-in"
        >
            <!-- {{ job.content }} -->
        </div>
    </div>
</template>

<script>
    import axios from "axios"
    import he from "he"

    export default {
        props: {
            jobId: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                job: null,
                content: null,
            }
        },

        created() {
            this.loadJob()
        },

        methods: {
            loadJob() {
                // NOTE: when changing job board, change in base.twig and Jobs.vue as well
                axios.get('https://boards-api.greenhouse.io/v1/boards/toyotaconnected/jobs/' + this.jobId)
                .then((response) => {
                    this.job = response.data;
                    this.content = he.decode(response.data.content);
                })
            },
        },
    }
</script>

<style lang="scss">
    div.article__lead-in p img:nth-of-type(1) {
        width: 100%;
        margin-bottom: 3rem;
    }

    .article--simple .article__header {
    margin-bottom: 1rem;
    }

    div.article__lead-in {
        ul {
            margin-top: 2rem;
            margin-bottom: 2rem;
            max-width: 38rem;
            margin-left: auto;
            margin-right: auto;
            list-style: none;
            padding: 0;

            li {
                margin-bottom: 1rem;
                position: relative;
                font-size: 1.0625rem;
                margin-bottom: 0.75rem;
                padding-left: 2rem;

                &::before {
                    position: absolute;
                    display: block;
                    height: 0.5rem;
                    width: 0.5rem;
                    color: #D62328;
                    content: "";
                    border-top: 8px solid;
                    border-left: 8px solid transparent;
                    top: 0.3125rem;
                    left: 0;
                }
            }

            ul {
                margin-top: 1rem;
                margin-left: 2rem;
            }
        }

        p {
            font-size: 1.0625rem;
            line-height: 1.5;
            margin-bottom: 1.5rem;
            max-width: 38rem;
            margin-left: auto;
            margin-right: auto;

            &:nth-of-type(1), &:nth-of-type(2) {
                max-width: none;
                margin-bottom: 0;
                font-size: 1.3125rem;
                line-height: 1.5;
            }

            &:nth-of-type(2) {
                margin: 2rem 0;
            }

            strong {
                display: block;
                font-size: 1.5rem;
                margin: 1rem 0;
                font-weight: 500;
                line-height: 1.1;
            }
        }

        h2 {
            font-size: 1.0625rem;
            line-height: 1.5;
            margin-bottom: 1.5rem;
            max-width: 38rem;
            margin-left: auto;
            margin-right: auto;

            strong {
                display: block;
                font-size: 1.5rem;
                margin: 1rem 0;
                font-weight: 500;
                line-height: 1.1;
            }
        }

    }

    #grnhse_app {
        max-width: 38rem;
        margin-left: auto;
        margin-right: auto;

        iframe {
            width: 100%;
        }
    }
</style>
